<!--begin header -->
<header class="header">
    <app-header></app-header>
</header>
<!--end header -->

<!--begin section-grey -->
<section class="section-white pb-3 page-content">
    <!--begin services-wrapper -->
    <div class="services-wrapper">
        <!--begin container -->
        <div class="container">
            <div class="row">
                <div class="col-12 mb-2">
                    <div class="container section1">
                        <img src="assets/images/Wallet-Launch-Webpage Banner.png" alt="International Payments within One Click - SingX">
                        <p>We have launched our very own SingX Wallet - top up once, use multiple times! 
                         You no longer have to transfer funds to us for every transaction. Simply top up your wallet once, and use those funds to make multiple overseas transfers, bill payments in India and mobile top ups anytime!​
                        </p>
                    </div>
                    <div class="topupwallet">
                        <h2>How to Top Up your SingX Wallet:</h2>
                        <img src="assets/images/Steps for Wallet Top up_1.png" alt="International Payments SingX Wallet">
                    </div>
                    <div class="walletservices">
                        <h2>Use your SingX Wallet for the following Services:</h2>
                    </div>

                    <div class="Global-Money-Transfer">
                        <div class="row billpay">
                          <div class="col-md-4 col-xs-12">
                            <img src="assets/images/wallet-remittance-image-02.png" class="img-fluid rounded-start" alt="Global Money Transfer - SingX">
                          </div>
                          <div class="col-md-8">
                            <div class="card-body">
                              <h3 class="card-title" style="">Global Money Transfers</h3>
                              <p class="card-text">Wish you could just book a transaction without logging in to your online banking account? Well, now you can! With the SingX Wallet, you can pay for your transfers using your Wallet balance with the click of a button!</p>
                             
                            </div>
                          </div>
                        </div>
                     </div>
                     <!-- <div class="Billpayment-India">
                        <div class="row billpay">
                            <div class="col-md-4 col-xs-12">
                                <img src="assets/images/bill pay image 2.png" class="img-fluid rounded-start" alt="International Bill Payments in India - SingX">
                              </div>
                            <div class="col-md-8">
                                <div class="card-body">
                                  <h3 class="card-title">Bill Payments in India</h3>
                                  <p class="card-text">Do you have bills to pay in India? Whether its electricity, credit cards, broadband, insurance, EMIs or anything really, we've got you covered! Simply login to your SingX dashboard and pay these bills in just a few clicks using your SingX Wallet balance!</p>
                                 
                                </div>
                              </div>
                         
                          
                        </div>
                     </div>
                     <div class="Global-Mobile-Topups">
                        <div class="row billpay">
                          <div class="col-md-4 col-xs-12">
                            <img src="assets/images/mobile-top-up-image-2.png" class="img-fluid rounded-start" alt="Global Mobile Top-ups -SingX">
                          </div>
                          <div class="col-md-8">
                            <div class="card-body">
                              <h3 class="card-title">Global Mobile Top-ups</h3>
                              <p class="card-text">Need to top up your family's Pre-paid mobile plan back home? With SingX, simply enter the country and mobile number and choose the plan you want to purchase. We'll do the rest!</p>
                             
                            </div>
                          </div>
                        </div>
                     </div> -->
                    
                </div>
            </div>
        </div>
        <!--end container -->
    </div>
    <!--end services-wrapper -->
</section>
<!--end section-grey -->


<!-- footer -->
<app-footer></app-footer>
